import { getIsAuthenticated } from 'ha/modules/AuthLogic/selectors';
import { fetchUserBillingInfo } from 'ha/modules/AuthLogic/actions';
import { AuthLogicTypes } from 'ha/modules/AuthLogic/constants';

import { openModal as openModalAction } from '../actions';
import { shouldDisplayModal } from '../selectors';
import { MODAL_DELAY_AFTER_ACTION as DELAY } from '../constants';

const isLogin = ({ type } = {}) => type === AuthLogicTypes.login;

const openModalAfterActions = ({ getState, dispatch }, action) => {
  if (isLogin(action) && getIsAuthenticated(getState())) {
    return dispatch(fetchUserBillingInfo()).then(() => {
      if (shouldDisplayModal(getState(), null)) {
        setTimeout(() => dispatch(openModalAction()), DELAY);
      }
    });
  }

  return Promise.resolve();
};

const openWeWantToPayModal = store => next => action => {
  next(action);

  return openModalAfterActions(store, action);
};

export { openWeWantToPayModal };
